import { render, staticRenderFns } from "./ProjectFormRequest.vue?vue&type=template&id=ba703ce4&scoped=true"
import script from "./ProjectFormRequest.vue?vue&type=script&lang=js"
export * from "./ProjectFormRequest.vue?vue&type=script&lang=js"
import style0 from "./ProjectFormRequest.vue?vue&type=style&index=0&id=ba703ce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba703ce4",
  null
  
)

export default component.exports